// extracted by mini-css-extract-plugin
export var SVGWrapper = "index-module--SVGWrapper--da91c";
export var iconContainer = "index-module--iconContainer--8b77d";